import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import { capitalize } from '../../../utils/string';

export function formatDate(date: Date): string {
  const formattedDate = format(date, 'EEEEEE, d MMMM', { locale: ru });

  return capitalize(formattedDate);
}
